import { useState } from "react";

import DstButton from "../../../../components/DstButton/DstButton";
import MultiSelectLiveDropdown from "../../../../components/MultiSelectLiveDropdown/MultiSelectLiveDropdown";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { LoadedPermissionsData } from "../../Permissions.d";
import { fetchRoleUsers } from "../../Permissions.functions";
import { PermissionAddUsersToRolePopup } from "./AddUsersToRolePopup.d";
import { addNewUsersToRole } from "./AddUsersToRolePopup.function";

const AddUsersToRolePopup = ({
  displayPage,
  language,
  openAddUsersModal,
  roleId,
  setLoaded,
  setOpenAddUsersModal,
  setRoleUsers,
}: PermissionAddUsersToRolePopup) => {
  const [usersToAdd, setUsersToAdd] = useState<number[]>([]);
  const [isUsersAdding, setIsUsersAdding] = useState(false);

  return (
    <Popup
      show={openAddUsersModal}
      onClose={() => setOpenAddUsersModal(false)}
      modalTitle={translate(language, "PAGES.PERMISSIONS.MODALS.ADD_USERS_TO_ROLE.TITLE")}
    >
      <div className="d-flex flex-column">
        <div className="flex-grow-1">
          <MultiSelectLiveDropdown
            category={["users"]}
            label={
              usersToAdd && usersToAdd.length > 0
                ? `${usersToAdd.length} ${translate(
                    language,
                    "PAGES.PERMISSIONS.MODALS.ADD_USERS_TO_ROLE.SELECTED_USERS"
                  )}`
                : translate(language, "PAGES.PERMISSIONS.MODALS.ADD_USERS_TO_ROLE.SELECT_USERS")
            }
            language={language}
            mockClass="rounded-0 rounded-end"
            toggleClass="min-w-100px border"
            onConfirm={(selectedUsers: any[]) => setUsersToAdd(selectedUsers.map((user) => user.value.id))}
            showFilterButton={false}
            clearItemsOnSend={false}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          <DstButton
            btnWidth="100px"
            variant="primary"
            value={translate(language, "GLOBAL.CONFIRM")}
            clickFunction={() => {
              setIsUsersAdding(true);
              addNewUsersToRole(
                language,
                usersToAdd,
                roleId,
                () => {
                  setLoaded((loaded: LoadedPermissionsData) => ({
                    ...loaded,
                    rolesUsers: { ...loaded.rolesUsers, [String(roleId)]: false },
                  }));
                  setOpenAddUsersModal(false);
                  fetchRoleUsers(String(roleId), setRoleUsers, setLoaded, displayPage);
                  setUsersToAdd([]);
                },
                () => {
                  setIsUsersAdding(false);
                }
              );
            }}
            btnClass="me-2"
            loading={isUsersAdding}
          />
        </div>
      </div>
    </Popup>
  );
};

export default AddUsersToRolePopup;
